export default "__VITE_ASSET__FSwBkOQr__"